import React from 'react'
import Link from 'gatsby-link'
import { Tag } from 'antd'


const Meta = (props) => {

  const { title, date, tags, updated } = props.data;

  return (
    <div className="component--posts-meta" >

      <h3>Meta Information</h3>

      <div className="info">
      { ! updated || date === updated ?
        (
          <span>This article was published on <code>{ date }</code> and is written by <Link to="/about-me">Dhruv Kumar Jha</Link> (me).</span>
        ) : (
          <span>This article was published on <code>{ date }</code>, updated on <code>{ updated }</code> and is written by <Link to="/about-me">Dhruv Kumar Jha</Link> (me).</span>
        )
      }
      </div>

      { props.series &&
        <div className="additional-info">This is part of series: <strong>{ props.series }</strong></div>
      }

      { tags && tags.length > 0 &&
      <div className="tags">
        <div className="key">Tags</div>
        <div className="value">
          { tags.map( tag => <Tag color="blue" key={tag}>{ tag }</Tag> ) }
        </div>
      </div>
      }

    </div>
  )

}


export default Meta



// WEBPACK FOOTER //
// ./src/global/components/posts/Meta.js